import { inject, Pipe, PipeTransform } from '@angular/core';
import { HelperUtilitiesService } from '../services/_core/helper-utilities/helper-utilities.service';


@Pipe({
  name: 'capitalize',
  standalone: true
})
export class CapitalizePipe implements PipeTransform {

  helpers = inject(HelperUtilitiesService);

  transform(value: any): any {
    return this.helpers.capitalizeString(value);
  }

}
